import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useStudentQuizCreate = () => {
  const createStudentQuizPostRequest = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v3/studentquiz/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createStudentQuizPostRequest);
};

export default useStudentQuizCreate;
